module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/bern-53b790770f2dc7e7236eb9c0b680a726.png";